import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CapabilityResponseDataSchema, UpdateCapabilityConfigBodySchema } from "schema"
import z from "zod"
import { capabilitiesQuery } from "../lib/capabilitiesQuery"
import { marketplaceCapabilitiesQuery } from "../lib/marketplaceCapabilitiesQuery"

type Response = {
  data: z.infer<typeof CapabilityResponseDataSchema>
}

type Props = z.input<typeof UpdateCapabilityConfigBodySchema> & { id: string }

export function useUpdateCapabilityConfigMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...data }: Props) => {
      const response = await axios.patch<Response>(`/capabilities/${id}/config`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: capabilitiesQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: marketplaceCapabilitiesQuery().queryKey })
    },
  })
}
